<template lang="pug">
v-app
  v-progress-linear(:active="loading" :indeterminate="loading" absolute top color="secondary")
  transition(name="fade")
    router-view
  re-mini-app
  re-snackbar
  re-confirm
  re-connection-warning
  re-global-loading
  ios-system-font(v-pre)
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { changeLocale } from './i18n'
import MiniApp from './components/utils/MiniApp.vue'
import Snackbar from './components/utils/Snackbar.vue'
import Confirm from './components/utils/Confirm.vue'
import ConnectionWarning from './components/utils/ConnectionWarning.vue'
import GlobalLoading from './components/utils/GlobalLoading.vue'

export default {
  name: 'App',

  components: {
    're-mini-app': MiniApp,
    're-snackbar': Snackbar,
    're-confirm': Confirm,
    're-connection-warning': ConnectionWarning,
    're-global-loading': GlobalLoading,
  },

  computed: {
    ...mapState({
      cashRegister: state => state.cashRegisters.cashRegister,
    }),

    loading() {
      return this.cashRegister === null && this.$route.name !== 'SignIn'
    },
  },

  created() {
    changeLocale()

    const darkTheme = localStorage.getItem('rekassa.kz-ui-darkTheme') === null || localStorage.getItem('rekassa.kz-ui-darkTheme') === 'true'
    this.$vuetify.theme.dark = darkTheme
    this.analyticsSetUserProperty({ key: 'dark_theme', value: darkTheme })

    if (this.$isCordova()) {
      window.cordova.getAppVersion.getVersionNumber().then((version) => {
        this.setCordovaBuildVersion(version)
      })

      // App launch count for review
      const appLaunchCount = parseInt(localStorage.getItem('rekassa.kz-tools-appLaunchCount') || 0, 10)
      localStorage.setItem('rekassa.kz-tools-appLaunchCount', appLaunchCount + 1)

      // Only for Android
      if (this.$isAndroid()) {
        // Check NFC and Android 8 above support for m4bank
        this.m4bankCheckCompatibility()
      }
    }
  },

  mounted() {
    // Use system font size on iOS
    if (this.$isCordova() && window.device.platform === 'iOS') {
      const iosSystemFontSize = getComputedStyle(document.getElementsByTagName('ios-system-font')[0]).getPropertyValue('font-size')
      let css = `html, body, .v-application, .v-input, .v-label { font-size: ${iosSystemFontSize} !important; }`
      if ((`${iosSystemFontSize}`).replace(/\D/g, '') >= 28) {
        css += ' .v-input input { max-height: none !important; }'
      }
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')

      head.appendChild(style)

      style.type = 'text/css'
      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }
    }

    // Hide Splash screen
    if (this.$isCordova()) {
      if (window.device.platform === 'iOS') {
        setTimeout(() => {
          navigator.splashscreen.hide()
          this.changeStatusBar()
        }, 3000)
      } else {
        navigator.splashscreen.hide()
        this.changeStatusBar()
      }
    }
  },

  methods: {
    ...mapActions({
      setCordovaBuildVersion: 'tools/setCordovaBuildVersion',
      m4bankCheckCompatibility: 'm4bank/checkCompatibility',
      analyticsSetUserProperty: 'analytics/setUserProperty',
    }),

    changeStatusBar() {
      const darkTheme = localStorage.getItem('rekassa.kz-ui-darkTheme') === null || localStorage.getItem('rekassa.kz-ui-darkTheme') === 'true'

      if (this.$isCordova()) {
        if (darkTheme) {
          window.StatusBar.styleLightContent()
          window.StatusBar.backgroundColorByHexString('#1E2E31')
        } else {
          window.StatusBar.styleDefault()
          window.StatusBar.backgroundColorByHexString('#F4F4F4')
        }
      }
    },
  },
}
</script>
